<div class="modal-header">
  <h3 class="modal-title">
    <i class="mdi mdi-checkbox-multiple-marked"></i><span class="ml-2">{{'auth.appVersion.title' | translate}}</span>
  </h3>
</div>

<div class="modal-body modal-height">

  <!-- Last version -->
  <ng-container *ngIf="!historyOpened">
    <div class="row">
      <div class="col-12">
        <header class="version-header">
          <h3 class="text-black font-weight-bolder">{{'auth.appVersion.lastVersion.title' | translate}}</h3>
          <span (click)="historyOpened =! historyOpened"
            class="show-history text-primary">{{'auth.appVersion.history.button' | translate}}</span>
        </header>

        <section class="version-body">
          <div class="version-details">
            <span class="text-black font-weight-bolder">
              {{'auth.appVersion.link' | translate}} {{lastVersion.version}}</span>
            <span>{{lastVersionDate}}</span>
          </div>
          <div class="version-description">
            {{lastVersion.description}}
          </div>
        </section>
      </div>
    </div>
  </ng-container>

  <!-- Version history list -->
  <ng-container *ngIf="historyOpened">
    <section class="row">
      <div class="col-12">

        <section class="version-header">
          <h3 class="text-black font-weight-bolder">{{'auth.appVersion.history.title' | translate}}</h3>
          <span (click)="historyOpened =! historyOpened"
            class="show-history text-primary">{{'auth.appVersion.history.return' | translate}}</span>
        </section>

        <ng-container *ngFor="let version of versionList;">
          <div class="card border mb-2">
            <div class="card-body">
              <div class="history-title mb-2">
                <span><b>{{'auth.appVersion.link' | translate}} {{version.version}}</b></span>
                <span>{{moment(version.date).fromNow()}}</span>
              </div>
              <div [class]="version.showMore ? '' : 'description-elipsis'">
                {{version.description}}
                <br>
                <div class="showMore-content">
                  <span class="text-primary mt-2" (click)="version.showMore =! version.showMore">
                    <div *ngIf="!version.showMore">{{'auth.appVersion.history.showMore' | translate}}</div>
                    <div *ngIf="version.showMore">{{'auth.appVersion.history.showLess' | translate}}</div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

      </div>
    </section>
  </ng-container>
</div>